import useFindStoresQuery from '@/api/queries/useFindStoresQuery';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import Pagination from '@/components/Pagination';
import { SearchProps } from '@/components/search/useSearch';
import { CustomerStoreEditPath } from '@/modules/supplier/paths';
import { Link } from 'react-router-dom';

interface StoreTableProps extends SearchProps {
  customerId?: string;
  supplierId?: string;
}

const StoreTable = ({
  searchQuery,
  page = 1,
  onChangePage = () => {},
  customerId,
  supplierId,
}: StoreTableProps) => {
  const { stores, isLoading, error, itemsPerPage } = useFindStoresQuery(page, searchQuery, {
    retailerId: customerId,
    supplierId,
  });

  if (!isLoading && !error && stores.items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-8">
        <p>No stores found.</p>
      </div>
    );
  }

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <table className={isLoading ? 'loading' : ''}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Customer Number</th>
            </tr>
          </thead>
          <tbody>
            {stores.items.map((store) => {
              if (store.id === undefined) {
                return;
              }
              return (
                <tr key={store.id}>
                  <td className="w-1/2">
                    <Link
                      to={CustomerStoreEditPath.withParams(store.retailerId, store.id)}
                      className="text-blue-500 hover:underline"
                    >
                      {store.name}
                    </Link>
                  </td>
                  <td>{store.customerCode}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {isLoading ? (
          <div role="status" className="loader">
            <SpinnerIcon />
            <span className="sr-only">Loading...</span>
          </div>
        ) : (
          ''
        )}
      </div>
      <div className="table-bottom">
        <Pagination
          currentPage={page}
          itemsPerPage={itemsPerPage}
          totalCount={stores.totalCount || 0}
          estimatedTotalCount={stores.estimatedTotalCount || 0}
          onClick={onChangePage}
        />
      </div>
    </div>
  );
};

export default StoreTable;
